import { connect } from 'react-redux';
import CallForSpeakers from './components/CallForSpeakers';
import {
    submitCFSForm,
    updateCFSFieldValue,
    updateFormStatus,
    resetFormAction,
    addSpeaker,
    updateSpeaker,
    removeSpeaker
} from './actions/cfsActions';

export const mapStateToProps = state => ({
    fields: state.cfs.fields,
    formFailed: state.cfs.formFailed,
    formSubmitInProgress: state.cfs.formSubmitInProgress,
    formSubmitted: state.cfs.formSubmitted
});

export const mapActionCreators = {
    submitCFSForm,
    updateCFSFieldValue,
    updateFormStatus,
    resetFormAction,
    addSpeaker,
    updateSpeaker,
    removeSpeaker
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(CallForSpeakers);
